var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEraser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .eraser_a {\n                fill: none !important;\n            }\n\n            .eraser_b {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "eraser_a",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "eraser_b",
    d: "M76.529,1919.8,73,1916.2,85.941,1903,93,1910.2l-7.774,7.93H93v1.7H83v-.026Zm14.118-9.6-4.706-4.806-6.081,6.209,4.706,4.794ZM83.39,1917.6l-4.706-4.794-3.331,3.392,1.866,1.912H82.9Z",
    transform: "translate(-67 -1895)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEraser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_eraser.3ac6e72000413353bf53fda54f95a09b.svg";